export type DemandStatus = string | undefined;

/* eslint-disable */
// Cores de status REATIVAS ao tema via CSS variables (definidas em index.css:
// :root = light, html[data-theme="dark"] = dark). Usar var() em vez de decidir
// a cor em JS evita o bug de cor "grudada" ao alternar tema (o card não
// re-renderiza no toggle, então um valor calculado em JS ficaria stale).
// dot = cor saturada, igual nos dois temas (sem staleness).

const DOT: Record<string, string> = {
    'pendente': '#6B7280',
    'em triagem': '#FFC107',
    'em contratação': '#F97316',
    'em contratacao': '#F97316',
    'aguardando execução': '#8041C7',
    'aguardando execucao': '#8041C7',
    'em execução': '#3498DB',
    'em execucao': '#3498DB',
    'em conferência': '#41C49F',
    'em conferencia': '#41C49F',
    'finalizada': '#0ABD17',
};

const BG_VAR: Record<string, string> = {
    'pendente': '--status-bg-pendente',
    'em triagem': '--status-bg-triagem',
    'em contratação': '--status-bg-contratacao',
    'em contratacao': '--status-bg-contratacao',
    'aguardando execução': '--status-bg-aguardando',
    'aguardando execucao': '--status-bg-aguardando',
    'em execução': '--status-bg-execucao',
    'em execucao': '--status-bg-execucao',
    'em conferência': '--status-bg-conferencia',
    'em conferencia': '--status-bg-conferencia',
    'finalizada': '--status-bg-finalizada',
};

export const getStatusDotColor = (status: DemandStatus): string => {
    const key = (status || '').toLowerCase();
    return DOT[key] || '#6B7280';
};

export const getStatusBgColor = (status: DemandStatus): string => {
    const key = (status || '').toLowerCase();
    const v = BG_VAR[key] || '--status-bg-pendente';
    return `var(${v})`;
};
